<template>
  <div id="trendsPage">
    <NavBar class="overflow-y-hidden"/>
    <v-main class="overflow-hidden">
      <div class="container-fluid">
        <div class="row no-gutters">
          <div class="col-auto pt-0 pl-0 ">
            <v-btn icon @click="$router.go(-1)">
              <i class="fa-solid fa-arrow-right fa-xl"></i></v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-10 col-md-6 card-bg mx-auto">
            <PostCard v-if="!postLoading" :item="post"/>
            <v-divider></v-divider>
           <div class="my-2 font16px"> # ترند های مرتبط</div>
            <div v-if="!hasResult" class="col-12 text-center mt-15">
              ترند های مرتبطی وجود ندارد
            </div>
            <masonry v-else
                     :cols="{default: 4, 1000: 3, 700: 2}" >
              <router-link v-for="(item,i) in posts" :key="i"
                           :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"
                           class="p-1 mx-auto d-block">
                <v-img v-if="item.FileCoverUrl !== null"
                       :src="$replaceHttps(item.FileCoverUrl)"
                       class=" rounded-11px"
                       :lazy-src="$replaceHttps(item.FileCoverUrl)">
                  <div class="p-2">
                    <div v-if="item.TypeStrucGallery ===2"><i
                        class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                    <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                    </div>
                  </div>
                </v-img>
                <v-img v-else :src="$replaceHttps(item.FileUrl)" class=" rounded-11px"
                       :lazy-src="$replaceHttps(item.FileUrl)">
                  <div class="p-2">
                    <div v-if="item.TypeStrucGallery ===2"><i
                        class="fa-solid fa-play white--text fa-lg shadow-lg"></i></div>
                    <div v-if="item.TypeStrucGallery ===1"><i class="fa-solid fa-images white--text fa-lg shadow"></i>
                    </div>
                  </div>
                </v-img>
              </router-link>
            </masonry>
          </div>
        </div>

      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import PostCard from "@/components/PostCard";
import NavBar from "@/components/NavBar";

export default {
  name: "TrendDetail",
 /* metaInfo: {
    title: 'ایوان خانه- جزئیات',
  },*/
  components: {NavBar, PostCard},
  data: () => ({
    post: {},
    postLoading: true,
    showLoaderDialog: false,
    posts:[],
    hasResult:true,
    pageTitle:""
  }),
  metaInfo() {
    return {
      title:"ایوان خانه - " +  this.pageTitle,
    };
  },
  watch:{
    '$route.query'() {
      this.getSpecialSocial()
      this.setPostView(this.$route.query.VendorSocialNetworkID)
    },
  },
  mounted() {
    this.getSpecialSocial()
    // this.setPostView(this.$route.query.VendorSocialNetworkID)
  },
  methods: {
    getSpecialSocial() {
      this.postLoading=true
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", this.$route.query.VendorSocialNetworkID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/SpecialSocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            let postFiles = []
            postFiles.push({src: json.FileUrl, type: json.TypeStrucGallery})
            if (json.FileUrl2 !== null) {
              postFiles.push({src: json.FileUrl2, type: json.FileType2})
            }
            if (json.FileUrl3 !== null) {
              postFiles.push({src: json.FileUrl3, type: json.FileType3})
            }
            if (json.FileUrl4 !== null) {
              postFiles.push({src: json.FileUrl4, type: json.FileType4})
            }
            if (json.FileUrl5 !== null) {
              postFiles.push({src: json.FileUrl5, type: json.FileType5})
            }
            if (json.FileUrl6 !== null) {
              postFiles.push({src: json.FileUrl6, type: json.FileType6})
            }
            if (json.FileUrl7 !== null) {
              postFiles.push({src: json.FileUrl7, type: json.FileType7})
            }
            if (json.FileUrl8 !== null) {
              postFiles.push({src: json.FileUrl8, type: json.FileType8})
            }
            if (json.FileUrl9 !== null) {
              postFiles.push({src: json.FileUrl9, type: json.FileType9})
            }
            if (json.FileUrl10 !== null) {
              postFiles.push({src: json.FileUrl10, type: json.FileType10})
            }
            json.files = postFiles


            let allHashtags = this.$store.getters.getHashtags
            let selectedHashtags = json.SelectedHashTags
            let hashtags = []
            if (selectedHashtags !== null && selectedHashtags.length > 0) {
              for (let i = 0; i < selectedHashtags.length; i++) {
                hashtags.push(allHashtags.find(x => x.HashTagID === selectedHashtags[i]))
              }
            }
            json.hashtags = hashtags


            let products = this.$store.getters.getProductsList

            let relatedProducts = []
            let selectedProducts = json.SelectedProducts
            if (selectedProducts !== null) {
              for (let i = 0; i < selectedProducts.length; i++) {
                relatedProducts.push(products.find(x => x.VendorProductID === selectedProducts[i]))
              }

              for (let i = 0; i < relatedProducts.length; i++) {
                relatedProducts[i].tip = relatedProducts[i].VendorProductTipViewModels[0]
              }
            }


            json.relatedProducts = relatedProducts


            this.post = json;
            this.getSimilarPosts(json.SelectedHashTags)
            this.postLoading = false
            this.showLoaderDialog = false
            this.pageTitle = json.Description.replace(/<\/?[^>]+(>|$)/g, "");
          })
          .catch(error => console.log('error', error));
    },
    getSimilarPosts(hashtags) {
      if (hashtags!== null && hashtags.length > 0) {
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();

        for (let i = 0; i < hashtags.length; i++) {
          urlencoded.append("SelectedHashTagIds[" + i + "]", hashtags[i]);
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "SearchSocialNetwork/SimilarPosts", requestOptions)
            .then(response => response.text())
            .then(result => {
              let json = JSON.parse(result)
              if (json.length > 0) {
                this.posts = json
                this.hasResult = true
              } else {
                this.hasResult = false
              }
              this.showMapDialog = true
              this.loadContent = true
            })
            .catch(error => console.log('error', error));
      } else {
        this.showMapDialog = true
        this.loadContent = true
      }
    },
    setPostView(id) {
      let visited = this.$store.getters.getPostsViewList
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("vendorSocialNetworkId", id);
      urlencoded.append("appUserId", this.$getUserData().appUserId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "SearchSocialNetwork/SetPostView", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()

          })
          .then(() => {
            if (resStatus === 200) {
              if (visited.indexOf(id) === -1) {
                this.$store.commit('addPostsVisited', id)
              }
            }
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
